import React, { useEffect, useCallback, useState, useRef} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import { deepOrange } from '@material-ui/core/colors';
import { useSelector } from 'react-redux';
import { isUndefined } from 'lodash';
import {
  Button,  Card,
  Grid, CardContent, makeStyles,
  Divider
} from '@material-ui/core';
import {  KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';

import './ScheduleModal2.scss';
import CheckboxList from './CheckBoxListData.js';
import { uploadContentService } from '../../../services';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),

  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },

});

const useStyles = makeStyles((theme) => ({
  containers: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  cardcontent: {
    padding: 40,
  },

  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 350,
    marginTop: 15,
    backgroundColor: '#FFFFFF',
    padding: 5,

  },
  avatar: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',

  },
  buttonMarkAll: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',
    width: 150,
    borderRadius: 0,
  },

  avatar1: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',
    maxWidth: '40px', maxHeight: '50px', minWidth: '30px', minHeight: '30px',
  },
  avatar2: {
    backgroundColor: deepOrange[800],
  },
  textColorChanger: {
    color: deepOrange[400],
  },
  buttonColor: {
    maxWidth: 150, maxHeight: 35, minWidth: 150, minHeight: 35,
    backgroundColor: deepOrange[500],
  },

})
);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),

  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    backgroundColor: "#252525",

  },
}))(MuiDialogActions);


export default function ScheduleModal2({ modalShow, modalState }) {
  const classes = useStyles();
  const fref = useRef();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [open, setOpen] = useState(modalShow);
  const [dynamicPlaylists, setDynamicPlaylists] = useState([]);
  const { user } = useSelector(state => state.userAuthentication);

  const handleClose = () => {
    modalState(false);
  };

  const getDynamicPlaylists = useCallback(async () => {
    if (!isUndefined(user)) {
      const res = await uploadContentService.uploadContentPlaylist(user);
      setDynamicPlaylists(res?.items);
    }
  }, [user]);

  const saveContentPlaylistSchedule = () => {
      fref.current.setFromOutside(startDate,endDate);
  }

  useEffect(() => {
    getDynamicPlaylists();
  }, [getDynamicPlaylists]);


  return (
    <div >
      <Dialog TransitionComponent={Transition} disableBackdropClick={true}
        maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle className="dialog-header" id="customized-dialog-title" onClose={handleClose}>PLANLÆG CONTENT</DialogTitle>
        <DialogContent dividers className="dialog-content"  >
          <Grid container item justify="center" lg={12} xs={12} md={12}>
            <Grid lg={6} md={6} xs={6} >
              <Card className="card-main" justify="center" cot   >
                <CardContent style={{ maxHeight: 700, overflow: 'auto' }}>
                  <Typography gutterBottom  >
                    <p className={classes.textColorChanger}> Vælg spillelisterne du vil tilføje filen til.</p>
                    <Divider />
                    <Grid container item className="dialog-checkbox">
                      {!isUndefined(dynamicPlaylists) ?
                        <CheckboxList playlists={dynamicPlaylists} startValidityDate={startDate}
                          endValidtiyDate={endDate} ref={fref} modalState={modalState} />
                        : ''}
                    </Grid>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid lg={6} md={6} xs={6}>
              <Card className="card-main" justify="center" cot  >
                <CardContent className={classes.cardcontent}>
                  <Typography >Fil information</Typography>
                  <Divider></Divider>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDateTimePicker
                      value={startDate}
                      onChange={setStartDate}
                      className={classes.textField}
                      format="yyyy/MM/dd HH:mma"
                      ampm={false}
                    />
                    <KeyboardDateTimePicker
                      value={endDate}
                      onChange={setEndDate}
                      className={classes.textField}
                      format="yyyy/MM/dd HH:mma"
                      ampm={false}
                    />
                  </MuiPickersUtilsProvider>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions classname="dialog-action">
          <Button onClick={handleClose} variant="contained" color="default">FORTYRD</Button>
          <Button variant="contained" onClick={saveContentPlaylistSchedule} className={classes.buttonColor}>GEM</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}